import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { ClienteUnidadeNegocioLinhaProducaoInsert } from '../unidade-negocio';

@Injectable({
    providedIn: 'root'
})
export class ClienteUnidadeNegocioHttpService {
    resource = 'cliente';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}/0/unidadenegocio`;
    }

    /** Insere a unidade de negócio e linha de produção diretamente no cliente informado */
    insertByCliente(entityInsert: ClienteUnidadeNegocioLinhaProducaoInsert): Observable<string> {
        return this.customHttp.post<string>(`${this.pathApi}/linhaproducao`, entityInsert);
    }
}
